// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3ECSK","inner":"Form_inner__1HWLR","range":"Form_range__29Owj","name":"Form_name__1iPi3","actions":"Form_actions__2teqb"};